import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 38"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m19.498 31.12-9.338 5.625a2.04 2.04 0 0 1-1.293.337 2.17 2.17 0 0 1-1.182-.45q-.506-.393-.787-.984-.281-.59-.113-1.322L9.26 23.695.992 16.55q-.563-.506-.704-1.153a2.24 2.24 0 0 1 .085-1.266q.225-.619.675-1.012.45-.394 1.237-.506l10.913-.957 4.219-10.012a2.02 2.02 0 0 1 .871-1.013 2.4 2.4 0 0 1 1.21-.337q.618 0 1.21.337.59.338.871 1.013l4.219 10.012 10.912.957q.788.112 1.238.506.45.393.675 1.012.225.62.084 1.266-.14.647-.703 1.153l-8.269 7.144 2.475 10.631q.169.731-.112 1.322t-.788.984a2.17 2.17 0 0 1-1.18.45 2.04 2.04 0 0 1-1.295-.337z"
    }, null, -1)
  ])))
}
export default { render: render }